import React from "react";
import { connect } from "react-redux";

const DiffList = ({ grn_lines }) => {
  if (
    grn_lines.filter(
      ({ counting_state }) => counting_state === "pending"
    ).length > 0
  ) {
    return null;
  }

  const diff_items = grn_lines.filter(
    ({ counting_state }) => counting_state !== "correct"
  );

  return (
    <ul className="diff-list">
      {diff_items.map(
        ({
          diff_quantity,
          counting_state,
          id,
          product,
        }) => {
          const label_status =
            counting_state === "over"
              ? "info-light"
              : "danger";
          const label_text =
            counting_state === "over" ? "nad stan" : "brak";
          return (
            <li className="diff-list__item" key={id}>
              <div className="item-label">
                <p
                  className={`label label--${label_status} label--round`}>
                  <span>
                    {label_text}{" "}
                    {counting_state === "over"
                      ? diff_quantity
                      : Number(diff_quantity) * -1}{" "}
                    szt.
                  </span>
                </p>
              </div>
              <div className="item-text">
                <p>
                  {product?.sku} {product?.name}
                </p>
              </div>
            </li>
          );
        }
      )}
    </ul>
  );
};

export default connect(({ grn }) => ({
  grn_lines: grn?.data?.grn_lines,
}))(DiffList);
